//import '@googlemaps/js-api-loader';
// import "google-maps";

import Cropper from "cropperjs";

window.cropper = null;

export default class vendor_image_cropperjs {
  constructor() {
    // Registering Events
    this.bindEvents();
    //this.geocodePosition();
    this.imagePreviewBOXID = "";
    this.outputSize = 512;
  }

  bindEvents = () => {
    cropperMain = this;
    // this.printCropperWorld();
    // this.doCroppingAction();

    $("#cropSubmitbtn").off("click.vendorCropper");
    $("#cropSubmitbtn").on("click.vendorCropper", this.cropperSubmit);
  };

  printCropperWorld = () => {};

  doCroppingAction = () => {
    var image = document.getElementById("image");
    var reader, file;
    var imagePreviewBoxId;

    // Bind once using event namespace; supports dynamically injected inputs
    $(document).off("change.vendorCropper", ".imageCropInput");
    $(document).on("change.vendorCropper", ".imageCropInput", (e) => {
      imagePreviewBoxId = e.target.defaultValue;

      if (e.target.files.length == 0) {
        return;
      }

      //Check if the file is image fill. if not then stop executing the function
      var imgExpression = /.*\.(jpg|jpeg|png|JPG|JPEG|PNG)$/;
      if (!e.target.files[0]["name"].match(imgExpression)) {
        return;
      }

      var files = e.target.files;
      var done = (url) => {
        image.src = url;
        window.$("#modalCropper").modal("show");
      };

      if (files && files.length > 0) {
        file = files[0];
        if (file === undefined) {
        }

        if (URL) {
          done(URL.createObjectURL(file));
        } else if (FileReader) {
          reader = new FileReader();
          reader.onload = (e) => {
            done(reader.result);
          };
          reader.readAsDataURL(file);
        }
      }
      // Destroy any previous cropper instance before creating new one
      if (globalThis.cropper && typeof globalThis.cropper.destroy === "function") {
        globalThis.cropper.destroy();
      }

      globalThis.cropper = new Cropper(image, {
        aspectRatio: 1,
        viewMode: 1,
        autoCropArea: 1,
        responsive: true,
        preview: $(".CropPreview"),
      });

      this.imagePreviewBOXID = imagePreviewBoxId;
    });

    // $("#cropSubmitbtn").on("click", () => {

    //   if (!imagePreviewBoxId) {
    //
    //     cropper.destroy();
    //     // window.bs_modal.modal("hide");
    //     window.$("#modalCropper").modal("hide");

    //     return;
    //   }

    //
    //   if (imagePreviewBoxId.length > 2) {
    //
    //
    //     var canvas = cropper.getCroppedCanvas({
    //       width: 426,
    //       height: 426,
    //     });

    //     canvas.toBlob((blob) => {
    //       var url = URL.createObjectURL(blob);
    //       var reader = new FileReader();
    //       reader.readAsDataURL(blob);
    //       reader.onloadend = () => {
    //         var base64data = reader.result;
    //

    //         // $.ajax({
    //         //   type: "POST",
    //         //   url: baseURL + "api/Vendor/UploadVendorImage",
    //         //   data: {
    //         //     image: base64data,
    //         //   },
    //         //   success: (data) => {
    //         //     bs_modal.hide();
    //         //     // alert("success upload image");
    //         //
    //         //     $.ajax({
    //         //       type: "POST",
    //         //       url: baseURL + "Vendor_details/upload",
    //         //       async: false,
    //         //       headers: { Authorization: X_API_KEY },
    //         //       data: { image: data },
    //         //       statusCode: {
    //         //         400: function () {
    //         //           alert("400 status code! user error");
    //         //         },
    //         //         500: function () {
    //         //           alert("500 status code! server error");
    //         //         },
    //         //       },
    //         //     });
    //         //   },
    //         // });
    //         cropper.destroy();
    //         // bs_modal.hide();
    //         // window.bs_modal.modal("hide");
    //         window.$("#modalCropper").modal("hide");
    //         // comment if above api is used
    //         // cropper = null;
    //
    //         document.getElementById(imagePreviewBoxId).src = base64data;
    //         document.getElementById(imagePreviewBoxId).value = 1;
    //         imagePreviewBoxId = "";
    //         // $(".image-preview-three").setAttribute("src", "base64data");
    //       };
    //     });
    //   }
    // });
  };
  cropperSubmit = async (res) => {
    if (!this.imagePreviewBOXID || !globalThis.cropper) {
      if (globalThis.cropper && typeof cropper.destroy === "function") {
        cropper.destroy();
      }
      // window.bs_modal.modal("hide");
      window.$("#modalCropper").modal("hide");

      return;
    }

    if (this.imagePreviewBOXID.length > 2) {
      const canvas = globalThis.cropper.getCroppedCanvas({
        width: this.outputSize,
        height: this.outputSize,
      });
      if (!canvas) {
        window.$("#modalCropper").modal("hide");
        return;
      }

      //To call compression function and obtain compressed image
      const base64dataCompressed = await this.compressAndGetDataUrl();
      if (!base64dataCompressed) {
        window.$("#modalCropper").modal("hide");
        return;
      }

      globalThis.cropper.destroy();
      window.$("#modalCropper").modal("hide");

      const previewEl = document.getElementById(this.imagePreviewBOXID);
      if (previewEl) {
        previewEl.src = base64dataCompressed;
        previewEl.value = 1;
        previewEl.style.width = "220px";
        previewEl.style.height = "220px";
        previewEl.style.objectFit = "cover";
      }
      this.imagePreviewBOXID = "";
    }
  };

  // Function to compress and get data URL
  compressAndGetDataUrl = () => {
    const canvas = globalThis.cropper.getCroppedCanvas({
      width: this.outputSize,
      height: this.outputSize,
    });
    if (!canvas) {
      return Promise.resolve(null);
    }
    return new Promise((resolve) => {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            resolve(null);
            return;
          }
          const reader = new FileReader();
          reader.onloadend = function () {
            resolve(reader.result);
          };
          reader.readAsDataURL(blob);
        },
        "image/webp",
        0.8,
      ); // Set the desired image quality (0.8 means 80% quality)
    });
  };
}

